import { render, staticRenderFns } from "./importTariffs.vue?vue&type=template&id=5123d894"
import script from "./importTariffs.vue?vue&type=script&lang=js"
export * from "./importTariffs.vue?vue&type=script&lang=js"
import style0 from "./importTariffs.vue?vue&type=style&index=0&id=5123d894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports